import { EpicSettingsReference, EpicSettingsReferenceFromJSON } from "./EpicSettingsReference";
import { EpicSettingsSlack, EpicSettingsSlackFromJSON } from "./EpicSettingsSlack";

export interface EpicSettings {
    limits?: Array<any>;
    slack?: EpicSettingsSlack;
    references?: Array<EpicSettingsReference>;
}

export function EpicSettingsFromJSON(json: any): EpicSettings {
    return {
        limits: (json["limits"] as Array<any>),
        slack: (json["slack"] === undefined || json["slack"] == null) ? undefined : EpicSettingsSlackFromJSON(json["slack"]),
        references: (json["references"] === undefined || json["references"] == null) ? undefined : (json["references"] as Array<any>).map(EpicSettingsReferenceFromJSON),
    }
}
